import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getRawConfigOption } from "~/store/selectors/selector.configOptions";
import { getLoggedUser } from "~/store/selectors/selector.users";
import { isFinancialManager, isMemberFinancialManager, isPowerUser } from "~/utils/userHelper";

export const RequireAdditionalPermissions = ({
  children,
  redirectTo,
  includePowerUser,
  checkQuickBooksIntegrationInUse,
}) => {
  const loggedUser = useSelector(getLoggedUser);
  const isQuickBooksInUse = useSelector(
    (state) => getRawConfigOption(state, "default_accounting_app") === "quickbooks"
  );

  const canAccess = includePowerUser
    ? isPowerUser(loggedUser) || isMemberFinancialManager(loggedUser)
    : isFinancialManager(loggedUser);

  return canAccess && (!checkQuickBooksIntegrationInUse || (checkQuickBooksIntegrationInUse && !isQuickBooksInUse)) ? (
    children
  ) : (
    <Navigate to={redirectTo} />
  );
};

RequireAdditionalPermissions.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
  includePowerUser: PropTypes.bool,
  checkQuickBooksIntegrationInUse: PropTypes.bool,
};

RequireAdditionalPermissions.defaultProps = {
  redirectTo: "/not-found",
  includePowerUser: false,
  checkQuickBooksIntegrationInUse: false,
};
